module.exports = __webpack_public_path__ + "img/icb-leo-elite-m@2x.0dd5f1ce.png";